import { usePecField } from 'components/form/core/hooks/useField'
import { useCallback, useMemo } from 'react'
import { useForm } from 'react-final-form'
import { metaPath } from 'util/metaPath'

import { CidadaoFormModel, DocumentoAssociadoFormModel, DocumentoGerenciavelFormModel } from '../types/model-cidadao'
import { applyDocumentosGerenciados, getDocumentosGerenciaveis } from '../utils-documentos-cidadao'

const path = metaPath<CidadaoFormModel>().dadosPessoais

export const useDocumentosGerenciaveis = (documentosAssociados: DocumentoAssociadoFormModel[]) => {
  const form = useForm()
  const {
    input: { value: cpf },
  } = usePecField({ name: path.cpf, subscription: { value: true } })
  const {
    input: { value: cns },
  } = usePecField({ name: path.cns, subscription: { value: true } })

  const documentosGerenciaveis = useMemo(() => getDocumentosGerenciaveis(documentosAssociados, cpf, cns), [
    documentosAssociados,
    cpf,
    cns,
  ])

  const aplicarDocumentosGerenciados = useCallback(
    (documentosGerenciados: DocumentoGerenciavelFormModel[]) => {
      const resultado = applyDocumentosGerenciados(documentosAssociados, documentosGerenciados)

      form.batch(() => {
        form.change(path.cpf.absolutePath(), resultado.cpf)
        form.change(path.cns.absolutePath(), resultado.cns)
        form.change(path.documentosAssociados.absolutePath(), resultado.documentosAssociados)
        if (resultado.cpf) form.change(path.stNaoPossuiCpf.absolutePath(), false)
      })
    },
    [form, documentosAssociados]
  )

  return { documentosGerenciaveis, aplicarDocumentosGerenciados }
}
